import { Box, Typography } from "@mui/material"
import { colors } from "theme"
import { Laptop } from "types/laptop"
import RatingCategory, {RatingCategoryProps} from "components/RatingCategory";

type ComparisonSummaryProps = {
  firstProduct: Laptop
  secondProduct: Laptop
}

export default function ComparisonSummary(props: ComparisonSummaryProps) {
  const summaryCategories: RatingCategoryProps[] = [
    {
      title: 'Performance',
      subTitle: 'based on processor, graphics, and memory',
      barColor: colors.red,
      score: props.firstProduct.performanceScore,
      secondScore: props.secondProduct.performanceScore,
    },
    {
      title: 'Portability',
      subTitle: 'based on weight, size, and battery life',
      barColor: colors.blue60,
      score: props.firstProduct.portabilityScore,
      secondScore: props.secondProduct.portabilityScore,
    },
    {
      title: 'Overall',
      subTitle: 'Average of summary scores',
      barColor: colors.green40,
      score: props.firstProduct.overallScore,
      secondScore: props.secondProduct.overallScore,
    }
  ]

  return (
    <>
      <Typography fontSize={30} fontWeight={200}>Laptop Summary</Typography>
      <Box sx={{borderBottom: `1px solid ${colors.background}`}} mt={2}/>
      {summaryCategories.map((category, i) => {
        return <RatingCategory key={i} {...category} paddingTopBar={0.5} />
      })}
    </>
  )
}